import React from 'react';
import ContactsFeature from '../features/contacts/Contacts';

const ContactsPage: React.FC = () => {
    return <ContactsFeature />;
};

export default ContactsPage;